/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_YearlyInputs */

const zh_pricing_yearly = /** @type {(inputs: Pricing_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年付`)
};

const en_pricing_yearly = /** @type {(inputs: Pricing_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yearly`)
};

const es_pricing_yearly = /** @type {(inputs: Pricing_YearlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anual`)
};

/**
* | output |
* | --- |
* | "Yearly" |
*
* @param {Pricing_YearlyInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_yearly = /** @type {((inputs?: Pricing_YearlyInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_YearlyInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_yearly(inputs)
	if (locale === "en") return en_pricing_yearly(inputs)
	return es_pricing_yearly(inputs)
});